import Rete from 'rete'

import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import CarouselSingleTemplate from './CarouselSingleTemplate'
import { lang } from '../../assets/lang'

export default class CarouselSingleComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.CAROUSEL_ITEM)

    this.data.component = CarouselSingleTemplate
    this.socket = config ? config.sockets : null
  }

  builder(node) {
    node.lingualName = lingualName.CAROUSEL_ITEM
    this.setConnection()
    
    const carouselSingleInput = new Rete.Input(CONST_SOCKET.CAROUSEL_SINGLE_INPUT, lang.carousel_item_socket_input_reply, this.socket.carouselSingleInput, false)
    // const carouselItemOutput = new Rete.Output(CONST_SOCKET.CAROUSEL_SINGLE_OUTPUT, 'Then', this.socket.carouselItemOutput, false)
    const carouselItemOutputButton = new Rete.Output(CONST_SOCKET.CAROUSEL_SINGLE_OUTPUT, lang.carousel_item_socket_output_buttons, this.socket.carouselSingleOutputButton, true)

    return node
      .addInput(carouselSingleInput)
      .addOutput(carouselItemOutputButton)
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.CAROUSEL_SINGLE_OUTPUT] = node.data
  }
  
  setConnection() {
    // CarouselItem may be connected to:
    // carouselItemOutput.combineWith(this.socket.quickReplyInput)
    this.socket.carouselSingleOutputButton.combineWith(this.socket.buttonInput)
  }
}